import { useTokens } from '@frontend/shared';
import { Spinner } from '@frontend/shared/web';
import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

export const AnonymousLayout = () => {
  const { tokens } = useTokens();
  const navigate = useNavigate();

  useEffect(() => {
    if (tokens) {
      navigate('/', { replace: true });
    }
  }, [tokens, navigate]);

  if (tokens === undefined) {
    return <Spinner />;
  }

  return <Outlet />;
};
